import { Injectable, InjectionToken, Inject } from '@angular/core';
import { DocumentService } from './document.service';
import { NGXLogger } from 'ngx-logger';

export const DocumentServiceToken = new InjectionToken(
  'document-service-token',
);

export const USE_CUSTOM_API_ENDPOINT = 'use-custom-api-endpoint';

@Injectable({ providedIn: 'root' })
export class DocumentServiceSwitcherService {
  public documentServices: DocumentService<any, any>[];
  public usedService: DocumentService<any, any>;

  constructor(
    @Inject(DocumentServiceToken) documentServices: any[],
    public logger: NGXLogger,
  ) {
    this.documentServices = documentServices;
    let uscae = localStorage.getItem(USE_CUSTOM_API_ENDPOINT) || 0;
    if (uscae) {
      uscae = Number(uscae);
    }
    this.usedService = this.documentServices[uscae] || this.documentServices[0];
    if (!this.usedService) {
      throw new Error('At least one document service must be defined');
    }
  }

  public useService(constructor): void {
    this.usedService.reset();
    this.usedService = this.documentServices.find(
      (ds) => ds instanceof constructor,
    );
    if (!this.usedService) {
      throw new Error('Could not find API service');
    }
    this.usedService.init();
    this.logger.info(
      '[DocumentServiceSwitcherService::useService] new document service',
      this.usedService,
    );
  }
}
